module.exports = __webpack_public_path__ + "static/media/inc-track.3a140c4f.svg";